import { render, staticRenderFns } from "./village-add-or-update.vue?vue&type=template&id=497d290a"
import script from "./village-add-or-update.vue?vue&type=script&lang=js"
export * from "./village-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports